import { Routes, Route } from "react-router-dom"
import Layout from "./layout"
import Login from "@/features/Login/Login"
import Success from "@/features/Success/Success"
import Error from "@/features/Error/Error"
import Otp from "@/features/OTP/otp"
export default function Router() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Login />} />
          <Route path="/otp" index element={<Otp/>} />
          <Route path="/success" index element={<Success/>} />
          <Route path="/error" element={<Error/>} />
        </Route>
      </Routes>
    </div>
  )
}
